<template>
    
  <div class="Typeahead">
    
     <div class="input-group  input-group-lg">
      <span class="input-group-addon">
        <span class="glyphicon glyphicon-search" aria-hidden="true"></span>
      </span>
      <input type="text"
             id="companyclient-typeahead"
             class="form-control"
             placeholder="Auftraggeber suchen..."
             autocomplete="off"
             v-model="query"
             @keydown.down="down"
             @keydown.up="up"
             @keydown.enter="hit($event)"
             @keydown.esc="reset"
             @input="update"/>
      
       <span class="input-group-btn">
        <button v-if="acdIntervalId && isAcdKey()" class="btn btn-success"  type="button" @click="stopAcdInterval">
          <span class="glyphicon" :class="{ 'glyphicon-pause': !loading, 'glyphicon-refresh': loading }" aria-hidden="true"></span>
        </button>
        <button v-if="!acdIntervalId && isAcdKey()" class="btn" type="button" @click="startAcdInterval">
          <span class="glyphicon glyphicon-play" aria-hidden="true"></span>
        </button>
      </span>
    </div>

    <div v-show="nothingFound" class="alert alert-warning" role="alert">Kein Auftraggeber gefunden / ausgewählt</div>

    <ul v-show="hasItems">
      <li v-for="(item, index) in items" :class="activeClass(index)" @mousedown="hit" @mousemove="setActive(index)">
        <span class="name" v-html="highlight(item.poolCallInNmber)"></span>
        <span class="screen-name" v-html="highlight(item.companyName)"></span>
      </li>
    </ul>
  </div>
</template>



<script>
import VueTypeahead from './common/typeahead.common'
import bus from './common/bus'
import { ACD_INTERVAL } from './common/misc.conf.js'

export default {
  extends: VueTypeahead,

  data () {
    return {
      //src: 'https://typeahead-js-twitter-api-proxy.herokuapp.com/demo/search',
      //src: bus.config.path + '/search/companyclient/2',
      limit: 10,
      minChars: 1,
      acdIntervalId: '',
      callingNumber: '',
    }
  },
  
  created: function () {
    bus.registerOnIdCompanyClient(this.onIdCompanyClient);
    bus.registerStopAcdInterval(this.stopAcdInterval);
  },

  beforeDestroy: function () {
    this.stopAcdInterval();
  },
  
  mounted: function () {
    
    // Wenn in der URL Called und/oder Calling angegeben sind http://localhost:8080/222/0891234567
    let path = _.trimStart(location.pathname, '/');
     //console.log('CompanyClientTypeahead:mounted:path: '+ path );
    if(path.length > 0){
      let aPath = path.split('/');
      this.query = aPath[0] + '!';
      this.callingNumber = (typeof aPath[1] == 'string') ?  aPath[1] : '';
      this.update();
      //this.hit();
       var obj = { Title: '', Url: '' };
      history.pushState(obj, obj.Title, obj.Url);
      //location.pathname = '/';
      //location.assign();
    }
    this.setFocus();
    this.startAcdInterval();

  },

  
 computed: {
    src: function () {
      return bus.config.path + '/search/companyclient/' + bus.call.idCompanyCallCenter;
    },
   

   
  },

  methods: {
    
    isAcdKey: function () {
      return !!bus.login.acdKey.length;
    },

    startAcdInterval: function(){
      this.acdCutErr = '';
      if(this.acdIntervalId == '' && this.isAcdKey() ){
        clearInterval(this.acdIntervalId);
        this.acdIntervalId = setInterval(this.acdInterval, ACD_INTERVAL);
        //console.log('startAcdInterval: '+this.acdIntervalId);
      }
    },
    
    stopAcdInterval: function(){
      clearInterval(this.acdIntervalId);
      //console.log('stopAcdInterval: '+this.acdIntervalId );
      this.acdIntervalId = '';
    },

    acdInterval: function() {
      if (!this.query){
        this.loading = true
        this.$http.get(bus.config.path + '/acd/cache/cut/'+ bus.login.companyCallCenter.acdTyp +'/' + this.getAcdKey() ).then((response) => {
          if(response.data.result == 200){
            this.stopAcdInterval()
            this.callingNumber = response.data.acdCache.request.callingNumber
            //this.query = response.data.acdCache.request.calledNumber + '!'
            this.searchCompanyClientByCallInNumber(response.data.acdCache.request.calledNumber + '!')
            //this.update()
            //this.setFocus()
          }else{
          }
          this.loading = false

        }, (response) => {
          // error callback
        });
        console.log('ACD_INTERVAL: '+ ACD_INTERVAL);
      }
    },
    
    // create object ACD and mov this function
    getAcdKey: function() {
      
      if(bus.login.companyCallCenter.acdTyp == 3){
        // cc Pronto REST/Schnttstelle Oder NFON
        // idCompanyCallCenter#acdKey -> 1231231#136
        return bus.call.idCompanyCallCenter + "%23" + bus.login.acdKey;
      }else{
        return bus.login.acdKey;
      }
      
      
    },
    
    
    searchCompanyClientByCallInNumber: function(callInNumber) {
      
      this.$http.get(this.src, {params: {q: callInNumber}} ).then((response) => {
        if(typeof response.data[0] === 'object'){
          let item = response.data[0]
          this.onHit(item)
        }else{
           // nichts gefunden
           // Fehlermendung: Kein Auftraggeber für %callInNumber% gefunden
        }
      }, (response) => {
        // error callback
        // Fehlermendung: unbekannter fehler: searchCompanyClientByCallInNumber(callInNumber);
      });
    },
    
    setFocus: function(){
      //console.log('setFocus');
      this.$nextTick(function () {
        document.getElementById("companyclient-typeahead").focus();
      })
    },

    onBeginSearch: function(){
      console.warn('emitIdCompanyClient(0) entfernen!');
      bus.emitIdCompanyClient(0);
      bus.emitResetCompanyClient();
      bus.emitIdUserClient(0);
    },
    
    onIdCompanyClient: function(idCompanyClient){
      if(idCompanyClient == 0){
        this.startAcdInterval();
        this.setFocus();
      };
    },
    
    
    onHitNew (query ) {
      console.log(query);
    },

    
    onHit (item ) {

      this.stopAcdInterval();    
      //this.$parent.$emit('onCompanyClient',item.idCompany);
      bus.callBegin(item.idCompany, item.idUserClient, item.poolCallInNmber, this.callingNumber);
      
      if(bus.login.companyCallCenter.advancedFeatures.search("autosuche") != -1){
        bus.emitMessageSearch(this.callingNumber);
      }
      this.callingNumber = '';
      
      this.reset();
    },
    
    highlight: function(value){
        let query = this.query.substring(0,1) == '%' ? this.query.substring(1) : this.query;
        return value.replace( RegExp("("+query+")","gi"), '<b>$1</b>' );
    }
  }
  
}
</script>



<style scoped>
.Typeahead {
  position: relative;
 
}

.Typeahead__input {
  width: 100%;
  font-size: 14px;
  color: #2c3e50;
  line-height: 1.42857143;
  box-shadow: inset 0 1px 4px rgba(0,0,0,.4);
  -webkit-transition: border-color ease-in-out .15s,-webkit-box-shadow ease-in-out .15s;
  transition: border-color ease-in-out .15s,box-shadow ease-in-out .15s;
  font-weight: 300;
  padding: 12px 26px;
  border: none;
  border-radius: 22px;
  letter-spacing: 1px;
  box-sizing: border-box;
}

.Typeahead__input:focus {
  border-color: #4fc08d;
  outline: 0;
  box-shadow: inset 0 1px 1px rgba(0,0,0,.075),0 0 8px #4fc08d;
}
  .alert{
    margin-top: 10px;
  }
  
.fa-times {
  cursor: pointer;
}

i {
  float: right;
  position: relative;
  top: 30px;
  right: 29px;
  opacity: 0.4;
}

ul {
  position: absolute;
  padding: 0;
  margin-top: 8px;
  min-width: 100%;
  background-color: rgb(255, 254, 234);
  list-style: none;
  border-radius: 4px;
  box-shadow: 0 0 10px rgba(0,0,0, 0.25);
  z-index: 1000;
}

li {
  padding: 10px 16px;
  border-bottom: 1px solid #ccc;
  cursor: pointer;
}

li:first-child {
  background-color: #b0e6cd;
  border-radius: 4px 4px 0 0;
}

li:last-child {
  border-radius: 0 0 4px 4px;
  border-bottom: 0;
}

li span{
  display: block;
  color: #2c3e50;
}

.active {
  background-color: #3aa373;
}

.active span {
  color: white;
}

.name {
  font-weight: 400;
  font-size: 18px;
}

.screen-name {
  font-style: italic;
}
</style>



// WEBPACK FOOTER //
// CompanyClientTypeahead.vue?bc854936